var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.51985 0C11.6662 0 15.0389 3.3727 15.0389 7.51907C15.0389 9.47532 14.2882 11.2595 13.0597 12.5986L15.477 15.0109C15.7033 15.2371 15.704 15.6031 15.4778 15.8294C15.3651 15.9436 15.216 16 15.0678 16C14.9203 16 14.7721 15.9436 14.6586 15.8309L12.212 13.3912C10.925 14.4219 9.2932 15.0389 7.51985 15.0389C3.37347 15.0389 0 11.6655 0 7.51907C0 3.3727 3.37347 0 7.51985 0ZM7.51985 1.15821C4.01203 1.15821 1.15821 4.01125 1.15821 7.51907C1.15821 11.0269 4.01203 13.8807 7.51985 13.8807C11.0269 13.8807 13.8807 11.0269 13.8807 7.51907C13.8807 4.01125 11.0269 1.15821 7.51985 1.15821Z",
    fill: "#B0B7C3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.f13099217abe02da1647334cb30fe61a.svg";
export { ForwardRef as ReactComponent };